<div class="dropdown-container" #dropdownContainer [class.full-width]="fullWidth" cdkOverlayOrigin #trigger="cdkOverlayOrigin">
  <div
    class="dropdown-button"
    [class.hover-enabled]="canOpen"
    (click)="toggleDropdown()"
    [ngClass]="{
      open: isOpen,
      disabled: isDisabled,
      'white-background': whiteBackground
    }"
  >
    <div class="label flex items-center">
      <rk-dropdown-icon
        [faIcon]="selectedOption?.faIcon"
        [legacyIcon]="selectedOption?.legacyIcon"
      ></rk-dropdown-icon>
      <span class="truncate" [class.opacity-50]="!selectedOption?.label && placeholder">
        {{ selectedOption?.label || placeholder || '' }}
      </span>
    </div>
    @if (canOpen) {
      <fa-icon [icon]="'chevron-down'" class="arrow"></fa-icon>
    }
  </div>
</div>

<ng-template
  cdkConnectedOverlay
  [cdkConnectedOverlayOrigin]="trigger"
  [cdkConnectedOverlayOpen]="isOpen"
  [cdkConnectedOverlayPositions]="overlayPositions"
  [cdkConnectedOverlayWidth]="dropdownContainer.offsetWidth"
  (overlayOutsideClick)="onOverlayOutsideClick($event)"
>
  <div class="rk-dropdown-options">
    <ng-container *ngFor="let option of options || []">
      <div class="rk-dropdown-option flex items-center" [ngClass]="{
          active: selectedOption?.value === option.value,
          disabled: option.disabled
        }"
        (click)="onOptionSelected(option)"
      >
        <rk-dropdown-icon
          [faIcon]="option.faIcon"
          [legacyIcon]="option.legacyIcon"
        ></rk-dropdown-icon>
        <span class="truncate">{{ option.label }}</span>
      </div>
    </ng-container>
  </div>
</ng-template>